import React from "react";
import ratio from "../../assets/media/svg/ratios/ratio.svg";
import ratio4x5 from "../../assets/media/svg/ratios/ratio4x5.svg";
import ratio16x9 from "../../assets/media/svg/ratios/ratio16x9.svg";

export default function () {
    return (
        <div className="row py-5 border-bottom mb-5 pt-0">
            <div className="col-xxl-3 p-5 text-center les-1">
                <i className="fa fa-exclamation-triangle text-primary my-2 my-2 h1"></i>
                <span className="d-block m-3 lh-2">
                    Only part of your image is displayed on the website.
                </span>
                <span className="my-3 d-block">
                    Picture vision area will be centered and will use the full width or height of your image.
                </span>
            </div>
            <div className="col-xxl-3 col-sm-4 p-5 text-center">
                <h6>
                    Example Image
                </h6>
                <img src={ratio} alt="" className="w-xxl-75 w-100" />
            </div>
            <div className="col-xxl-3 col-sm-4 p-5 text-center">
                <h6>
                    Ratio 16:9
                </h6>
                <img src={ratio16x9} alt="" className="w-xxl-75 w-100" />
            </div>
            <div className="col-xxl-3 col-sm-4 p-5 text-center">
                <h6>
                    Ratio 4:5
                </h6>
                <img src={ratio4x5} alt="" className="w-xxl-75 w-100" />
            </div>
        </div>
    );
}